import styled from 'styled-components';
import { theme } from 'styles';
import { CenterFlex, Flex } from 'UI';

export const FlexRow = styled(Flex)`
  &:empty {
    display: none;
  }
`;

export const QuantityBubble = styled(CenterFlex)<{ type: 'blue' | 'grey' }>`
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
  border-radius: 20px;
  background-color: ${({ type }) => (type === 'grey' ? theme.color.grey55 : theme.color.info)};
`;
